import {createContext, Dispatch, SetStateAction} from "react";
import {BrandMapStates} from "@/pages/brandMap/context/BrandMapContext";

import {MenuOrder} from "@devour/client";


export interface IRestaurantContext {
    setIsUpdateTriggered?: Dispatch<SetStateAction<boolean>>; // Trigger re-render of parent NewCheckout
    activeMenuItemId?: string;
    setActiveMenuItemId?: Dispatch<SetStateAction<string>>;
    embeddedMenu?: boolean;
    setCheckoutState?: Dispatch<SetStateAction<BrandMapStates>>;
    menuOrderId?: string;
    isDigitalStore?: boolean;
    isDevourStore?: boolean;
    restaurantId: string;
    menuOrder?: MenuOrder;
}

const RESTAURANT_DEFAULT_VALUE: IRestaurantContext = {
    activeMenuItemId: "",
    setActiveMenuItemId: () => {
    },
    embeddedMenu: undefined,
    setCheckoutState: () => {
    },
    menuOrderId: "",
    restaurantId: "",
    isDevourStore: false,
    isDigitalStore: false,
    menuOrder: null,
};

export const RestaurantContext = createContext<IRestaurantContext>(RESTAURANT_DEFAULT_VALUE);
